<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container container-custom margin_30_95">
            <h1 class="fadeInUp"><span></span>My Account</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10" v-if="userStatus == 1">
            <div class="isotope-wrapper">
              <div class="row">
                <!-- <Cards /> -->

                <Chart />
              </div>
            
            </div>
            <div class="box_general" v-if="roleId == 3">
              <div class="header_box">
                <h5 class="d-inline-block text-center">
                  List Of Offers Around You
                </h5>
              </div>
              <div class="list_general" style="overflow-x: auto">
                <JqueryTable />
              </div>
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <div class="col-lg-8" v-else>
            <center><h2>Account Inactive</h2></center>
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
// import axios from 'axios'
// import Alert from "../cmps/Alert";
// import API from "../services/index";
import router from "../routes";
import Frontendlayout from "../layouts/Frontendlayout.vue";
// import Cards from "../cmps/Cards.vue";
import Chart from "../cmps/Chart.vue";
import Sidebar from "../layouts/Sidebar.vue";
import JqueryTable from "@/cmps/JqueryTable.vue";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      userStatus: localStorage.getItem("user_status"),
    };
  },
  components: {
    Frontendlayout,
    Chart,
    JqueryTable,
   // Cards,
    Sidebar,
  },
  beforeMount() {
    this.checkToken();
  },
  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        router.push("/signin");
      }
    },
  },
};
</script>
<style  scoped>
</style>